
(function () {
  if (window.IVRViceReviewsContinuous && typeof window.IVRViceReviewsContinuous.scan === 'function') {
    window.IVRViceReviewsContinuous.scan(document);
    return;
  }

  const instances = new Set();
  const ROOT_SELECTOR = '[data-vice-marquee]';

  function numberBetween(value, fallback, min, max) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? Math.min(max, Math.max(min, parsed)) : fallback;
  }

  function textOf(node) {
    if (!node) return '';
    const copy = node.cloneNode(true);
    copy.querySelectorAll('script, style, .jdgm-rev__pics, .jdgm-rev__video, .jdgm-rev__actions, .jdgm-rev__reply').forEach((el) => el.remove());
    return (copy.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function element(tag, className, content) {
    const el = document.createElement(tag);
    el.className = className;
    if (content !== undefined && content !== null) el.textContent = content;
    return el;
  }

  function scoreOf(node) {
    const starsNode = node.querySelector('.jdgm-rev__rating, .jdgm-rev__stars, [data-score], [data-rating]');
    if (!starsNode) return null;
    const strings = [
      starsNode.getAttribute('data-score'),
      starsNode.getAttribute('data-rating'),
      starsNode.getAttribute('aria-label'),
      starsNode.getAttribute('title'),
      node.getAttribute('data-rating')
    ];
    for (const value of strings) {
      if (!value) continue;
      const match = String(value).match(/(?:^|[^\d])([0-5](?:[.,]\d)?)(?:\s*(?:stars?|estrelas?|\/\s*5|out of 5)|$)/i);
      if (match) return numberBetween(match[1].replace(',', '.'), null, 0, 5);
    }
    const icons = Array.from(starsNode.querySelectorAll('.jdgm-star'));
    if (icons.length) {
      const full = icons.filter((icon) => icon.classList.contains('jdgm--on')).length;
      const half = icons.filter((icon) => icon.classList.contains('jdgm--half')).length;
      if (full + half > 0) return Math.min(5, full + half / 2);
    }
    const starsText = textOf(starsNode);
    const glyphs = (starsText.match(/★/g) || []).length;
    return glyphs > 0 ? Math.min(5, glyphs) : null;
  }

  function collectReviews(source) {
    const selectors = '.jdgm-rev, .jdgm-rev-v2025, [data-jdgm-review-id]';
    const nodes = Array.from(source.querySelectorAll(selectors)).filter((node) => {
      return !node.parentElement || !node.parentElement.closest(selectors);
    });
    const seen = new Set();
    const records = [];
    for (const node of nodes) {
      const name = textOf(node.querySelector('.jdgm-rev__author, .jdgm-rev__author-name, [itemprop="author"]'));
      const title = textOf(node.querySelector('.jdgm-rev__title, .jdgm-review-title'));
      const body = textOf(node.querySelector('.jdgm-rev__body, .jdgm-review-body, [itemprop="reviewBody"]'));
      const comment = body || title;
      if (!comment) continue;
      const rating = scoreOf(node);
      const stamp = node.querySelector('.jdgm-rev__timestamp, .jdgm-rev__date');
      const rawDate = stamp && stamp.getAttribute('datetime');
      const date = rawDate ? new Date(rawDate).toLocaleDateString('pt-BR') : textOf(stamp);
      const rawId = node.getAttribute('data-review-id') || node.getAttribute('data-jdgm-review-id') || node.id || '';
      const key = rawId || [name, title, comment, rating].join('|');
      if (seen.has(key)) continue;
      seen.add(key);
      records.push({ key, name: name || 'Cliente VICE', title: body && title && title !== body ? title : '', comment, rating, date });
    }
    return records;
  }

  class ReviewsLoop {
    constructor(root) {
      this.root = root;
      this.shell = root.querySelector('[data-vice-rm-shell]');
      this.viewport = root.querySelector('[data-vice-rm-viewport]');
      this.track = root.querySelector('[data-vice-rm-track]');
      this.source = root.querySelector('[data-vice-review-sources]') || root.querySelector('.vice-product-reviews__app');
      this.staticMode = root.dataset.viceRmStatic === 'true';
      this.controls = {
        previous: root.querySelector('[data-vice-rm-prev]'),
        next: root.querySelector('[data-vice-rm-next]'),
        toggle: root.querySelector('[data-vice-rm-toggle]')
      };
      this.speed = numberBetween(root.dataset.viceRmSpeed, 18, 6, 50);
      this.direction = root.dataset.viceRmDirection === 'right' ? -1 : 1;
      this.pauseHover = root.dataset.viceRmHover !== 'false';
      this.enabled = root.dataset.viceRmEnabled !== 'false';
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.manualPaused = this.reduced.matches;
      this.visible = typeof IntersectionObserver === 'undefined';
      this.hovered = false;
      this.keyboardFocus = false;
      this.dragging = false;
      this.active = false;
      this.destroyed = false;
      this.records = [];
      this.signature = '';
      this.offset = 0;
      this.cycleWidth = 0;
      this.lastFrame = 0;
      this.frame = 0;
      this.pointerId = null;
      this.pointerX = 0;
      this.pointerStart = 0;
      this.dragMoved = false;
      this.resumeTimer = null;
      this.syncTimer = null;
      this.abort = new AbortController();
      this.onFrame = this.onFrame.bind(this);
    }

    init() {
      if (!this.enabled || !this.shell || !this.viewport || !this.track || !this.source) return;
      const signal = this.abort.signal;

      if (this.controls.toggle) {
        this.controls.toggle.addEventListener('click', () => {
          this.manualPaused = !this.manualPaused;
          this.updateToggle();
          this.syncMotion();
        }, { signal });
      }
      if (this.controls.previous) {
        this.controls.previous.addEventListener('click', () => this.nudge(-1), { signal });
      }
      if (this.controls.next) {
        this.controls.next.addEventListener('click', () => this.nudge(1), { signal });
      }
      this.viewport.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.keyboardFocus = true;
        this.nudge(event.key === 'ArrowRight' ? 1 : -1);
      }, { signal });

      this.viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (!this.active || this.records.length < 2) return;
        this.dragging = true;
        this.pointerId = event.pointerId;
        this.pointerX = event.clientX;
        this.pointerStart = event.clientX;
        this.dragMoved = false;
        this.keyboardFocus = false;
        this.clearResume();
        try { this.viewport.setPointerCapture(event.pointerId); } catch (error) {}
        this.syncMotion();
      }, { signal });

      this.viewport.addEventListener('pointermove', (event) => {
        if (!this.dragging || event.pointerId !== this.pointerId) return;
        const dx = event.clientX - this.pointerX;
        if (Math.abs(event.clientX - this.pointerStart) > 4) {
          this.dragMoved = true;
          this.viewport.classList.add('is-dragging');
          if (event.cancelable) event.preventDefault();
        }
        if (this.dragMoved && this.cycleWidth > 0) {
          this.offset = this.wrap(this.offset - dx);
          this.paint();
        }
        this.pointerX = event.clientX;
      }, { signal });

      const endDrag = (event) => {
        if (!this.dragging || event.pointerId !== this.pointerId) return;
        this.dragging = false;
        this.pointerId = null;
        this.viewport.classList.remove('is-dragging');
        try { if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId); } catch (error) {}
        this.pauseBriefly();
      };
      this.viewport.addEventListener('pointerup', endDrag, { signal });
      this.viewport.addEventListener('pointercancel', endDrag, { signal });
      this.viewport.addEventListener('lostpointercapture', () => {
        if (this.dragging) {
          this.dragging = false;
          this.pointerId = null;
          this.viewport.classList.remove('is-dragging');
          this.pauseBriefly();
        }
      }, { signal });

      this.shell.addEventListener('pointerenter', (event) => {
        if (this.pauseHover && event.pointerType === 'mouse') {
          this.hovered = true;
          this.syncMotion();
        }
      }, { signal });
      this.shell.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') {
          this.hovered = false;
          this.syncMotion();
        }
      }, { signal });
      this.shell.addEventListener('keydown', (event) => {
        if (event.key === 'Tab' || event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          this.keyboardFocus = true;
          this.syncMotion();
        }
      }, { signal });
      this.shell.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (this.destroyed) return;
          if (!this.shell.contains(document.activeElement)) {
            this.keyboardFocus = false;
            this.syncMotion();
          }
        }, 0);
      }, { signal });

      document.addEventListener('visibilitychange', () => this.syncMotion(), { signal });
      this.reduced.addEventListener('change', (event) => {
        if (event.matches) this.manualPaused = true;
        this.updateToggle();
        this.syncMotion();
      }, { signal });

      if (typeof IntersectionObserver !== 'undefined') {
        this.intersection = new IntersectionObserver((entries) => {
          this.visible = entries.some((entry) => entry.isIntersecting);
          this.syncMotion();
        }, { rootMargin: '100px 0px', threshold: 0.01 });
        this.intersection.observe(this.root);
      }
      if (typeof ResizeObserver !== 'undefined') {
        this.resizer = new ResizeObserver(() => {
          if (!this.active) return;
          window.clearTimeout(this.resizeTimer);
          this.resizeTimer = window.setTimeout(() => this.staticMode ? this.measureStatic() : this.build(), 120);
        });
        this.resizer.observe(this.root);
      }

      this.observer = new MutationObserver(() => {
        window.clearTimeout(this.syncTimer);
        this.syncTimer = window.setTimeout(() => this.syncReviews(), 250);
      });
      this.observer.observe(this.source, { childList: true, subtree: true });

      if (this.staticMode) this.attachStatic();
      else this.syncReviews();
      this.updateToggle();
      if (!this.staticMode) {
        [500, 1600, 4000, 8500].forEach((delay) => {
          window.setTimeout(() => {
            if (!this.destroyed) this.syncReviews();
          }, delay);
        });
      }
    }

    attachStatic() {
      const segment = this.track.querySelector('[data-vice-rm-segment]');
      if (!segment) return;
      this.records = Array.from(segment.querySelectorAll('.vice-reviews-loop__card')).map((_, i) => ({ key: 'real-' + i }));
      const ssr = this.root.querySelector('[data-vice-rm-ssr]');
      if (ssr && typeof DOMParser !== 'undefined') {
        try {
          const html = ssr.content ? ssr.content.textContent : ssr.textContent;
          if (html && html.includes('jdgm-rev')) {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const ssrReviews = collectReviews(parsed);
            if (ssrReviews.length > this.records.length) {
              this.records = ssrReviews;
              this.track.classList.add('is-js-driven');
              this.build();
              return;
            }
          }
        } catch (error) {
          this.root.dataset.viceRmSsrFallback = 'true';
        }
      }
      this.active = this.records.length > 0;
      this.shell.hidden = false;
      this.root.classList.add('vice-product-reviews--marquee-ready');
      let currentX = 0;
      try {
        const transform = window.getComputedStyle(this.track).transform;
        if (transform && transform !== 'none' && window.DOMMatrixReadOnly) {
          currentX = new DOMMatrixReadOnly(transform).m41;
        }
      } catch (error) {
        currentX = 0;
      }
      this.cycleWidth = segment.getBoundingClientRect().width;
      this.offset = this.wrap(-currentX);
      this.track.classList.add('is-js-driven');
      this.paint();
      this.syncMotion();
    }

    measureStatic() {
      const segment = this.track.querySelector('[data-vice-rm-segment]');
      if (!segment) return;
      const previous = this.cycleWidth;
      this.cycleWidth = segment.getBoundingClientRect().width;
      if (previous > 0 && this.cycleWidth > 0) this.offset = this.wrap((this.offset / previous) * this.cycleWidth);
      else this.offset = this.wrap(this.offset);
      this.paint();
      this.syncMotion();
    }

    makeCard(record, clone) {
      const card = element('article', 'vice-reviews-loop__card');
      card.setAttribute('role', 'listitem');
      if (clone) {
        card.setAttribute('aria-hidden', 'true');
        card.inert = true;
      }
      const top = element('div', 'vice-reviews-loop__card-top');
      const stars = element('span', 'vice-reviews-loop__stars', '★★★★★');
      if (record.rating !== null) {
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', record.rating + ' de 5 estrelas');
        const fill = element('span', 'vice-reviews-loop__stars-fill', '★★★★★');
        fill.style.width = (record.rating / 5 * 100) + '%';
        fill.setAttribute('aria-hidden', 'true');
        stars.append(fill);
      } else {
        stars.setAttribute('aria-label', 'Avaliação');
      }
      top.append(stars);
      if (record.date) top.append(element('span', 'vice-reviews-loop__date', record.date));
      card.append(top);
      card.append(element('strong', 'vice-reviews-loop__author', record.name));
      if (record.title) card.append(element('p', 'vice-reviews-loop__title', record.title));
      card.append(element('p', 'vice-reviews-loop__comment', record.comment));
      return card;
    }

    wrap(value) {
      if (this.cycleWidth <= 0) return 0;
      return ((value % this.cycleWidth) + this.cycleWidth) % this.cycleWidth;
    }

    paint() {
      this.track.style.transform = 'translate3d(' + (-this.offset).toFixed(2) + 'px,0,0)';
    }

    build() {
      if (!this.records.length || this.destroyed || !this.shell || !this.viewport) return;
      const fraction = this.cycleWidth ? this.offset / this.cycleWidth : 0;
      this.shell.hidden = false;
      this.track.replaceChildren();
      const segment = element('div', 'vice-reviews-loop__segment');
      segment.setAttribute('role', 'list');
      segment.setAttribute('data-vice-rm-segment', '');
      this.records.forEach((record) => segment.append(this.makeCard(record, false)));
      this.track.append(segment);

      let count = 0;
      const fillWidth = this.viewport.clientWidth + 100;
      while (segment.getBoundingClientRect().width < fillWidth && count < 20) {
        this.records.forEach((record) => segment.append(this.makeCard(record, true)));
        count += 1;
      }

      const duplicate = segment.cloneNode(true);
      duplicate.setAttribute('aria-hidden', 'true');
      duplicate.inert = true;
      this.track.append(duplicate);
      this.cycleWidth = segment.getBoundingClientRect().width;
      this.offset = this.wrap(fraction * this.cycleWidth);
      this.paint();
      this.active = this.cycleWidth > 0;
      this.root.classList.add('vice-product-reviews--marquee-ready');
      const label = this.root.querySelector('[data-vice-rm-label]');
      if (label) label.textContent = this.records.length + (this.records.length === 1 ? ' avaliação exibida' : ' avaliações exibidas');
      this.syncMotion();
    }

    syncReviews() {
      if (this.staticMode || this.destroyed || this.dragging) return;
      const records = collectReviews(this.source);
      if (!records.length) return;
      const signature = records.map((record) => record.key + ':' + record.rating + ':' + record.comment).join('\n');
      if (signature === this.signature && this.active) return;
      this.signature = signature;
      this.records = records;
      this.build();
    }

    nudge(direction) {
      if (!this.active || this.cycleWidth <= 0) return;
      const card = this.track.querySelector('.vice-reviews-loop__card');
      const gap = numberBetween(parseFloat(getComputedStyle(this.root).getPropertyValue('--vice-rm-gap')), 20, 0, 80);
      const step = card ? card.getBoundingClientRect().width + gap : 300;
      this.offset = this.wrap(this.offset + step * direction);
      this.paint();
      this.pauseBriefly();
    }

    clearResume() {
      if (this.resumeTimer) window.clearTimeout(this.resumeTimer);
      this.resumeTimer = null;
      this.pauseUntil = 0;
    }

    pauseBriefly() {
      this.clearResume();
      this.pauseUntil = performance.now() + 1600;
      this.syncMotion();
      this.resumeTimer = window.setTimeout(() => {
        this.pauseUntil = 0;
        this.syncMotion();
      }, 1650);
    }

    updateToggle() {
      const toggle = this.controls.toggle;
      if (!toggle) return;
      toggle.setAttribute('aria-pressed', this.manualPaused ? 'true' : 'false');
      toggle.setAttribute('aria-label', this.manualPaused ? 'Retomar movimento automático' : 'Pausar movimento automático');
      const symbol = toggle.querySelector('[data-vice-rm-toggle-symbol]');
      const text = toggle.querySelector('[data-vice-rm-toggle-text]');
      if (symbol) symbol.textContent = this.manualPaused ? '▶' : 'Ⅱ';
      if (text) text.textContent = this.manualPaused ? 'Continuar' : 'Pausar';
    }

    canMove() {
      return this.active && this.records.length > 1 && this.visible && !document.hidden &&
        !this.manualPaused && !this.dragging && !this.hovered && !this.keyboardFocus &&
        (!this.pauseUntil || performance.now() >= this.pauseUntil);
    }

    syncMotion() {
      if (this.destroyed) return;
      if (this.canMove()) {
        if (!this.frame) {
          this.lastFrame = 0;
          this.frame = window.requestAnimationFrame(this.onFrame);
        }
      } else {
        if (this.frame) window.cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.lastFrame = 0;
      }
    }

    onFrame(now) {
      this.frame = 0;
      if (!this.canMove()) return;
      if (this.lastFrame) {
        const dt = Math.min(0.05, Math.max(0, (now - this.lastFrame) / 1000));
        this.offset = this.wrap(this.offset + this.direction * this.speed * dt);
        this.paint();
      }
      this.lastFrame = now;
      this.frame = window.requestAnimationFrame(this.onFrame);
    }

    destroy() {
      this.destroyed = true;
      this.abort.abort();
      this.observer && this.observer.disconnect();
      this.intersection && this.intersection.disconnect();
      this.resizer && this.resizer.disconnect();
      if (this.frame) window.cancelAnimationFrame(this.frame);
      window.clearTimeout(this.resumeTimer);
      window.clearTimeout(this.syncTimer);
      window.clearTimeout(this.resizeTimer);
      instances.delete(this);
    }
  }

  function scan(container) {
    const roots = [];
    if (container.matches && container.matches(ROOT_SELECTOR)) roots.push(container);
    if (container.querySelectorAll) roots.push(...container.querySelectorAll(ROOT_SELECTOR));
    for (const root of roots) {
      if (root.__viceReviewsLoop) continue;
      const instance = new ReviewsLoop(root);
      root.__viceReviewsLoop = instance;
      instances.add(instance);
      instance.init();
    }
  }

  document.addEventListener('shopify:section:unload', (event) => {
    for (const instance of Array.from(instances)) {
      if (event.target === instance.root || event.target.contains(instance.root)) {
        instance.destroy();
        delete instance.root.__viceReviewsLoop;
      }
    }
  });
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  window.IVRViceReviewsContinuous = { scan };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  } else {
    scan(document);
  }
})();
